let PageCachePlugin = {}
PageCachePlugin.install = function (Vue, options) {
  // keep alive 缓存实例
  PageCachePlugin.keepAliveInstance = null
  // 开启页面缓存开关
  Vue.prototype.enableViewCache = function (viewName) {
    this.$router.getRouteByName(viewName).meta.keepalive = true
  }
  // 关闭页面缓存开关
  Vue.prototype.disableViewCache = function (viewName) {
    this.$router.getRouteByName(viewName).meta.keepalive = false
  }
  // 清除指定的页面缓存
  Vue.prototype.clearViewCache = function (viewName) {
    if (PageCachePlugin.keepAliveInstance) {
      let cache = PageCachePlugin.keepAliveInstance.cache
      let keys = PageCachePlugin.keepAliveInstance.keys
      if (cache) {
        for (let key in cache) {
          let item = cache[key]
          if (item.tag.indexOf('-' + viewName) > 0) {
            console.log(' clear view cache : ' + item.tag)
            let index = keys.indexOf(key)
            if (index > -1) {
              keys.splice(index, 1)
            }
            cache[key].componentInstance.$destroy()
            delete cache[key]
          }
        }
      }
    }
  }
  // 清除所有页面缓存
  Vue.prototype.clearAllViewCache = function () {
    if (PageCachePlugin.keepAliveInstance) {
      let cache = PageCachePlugin.keepAliveInstance.cache
      let keys = PageCachePlugin.keepAliveInstance.keys
      if (cache) {
        for (let key in cache) {
          let item = cache[key]
          console.log(' clear view cache : ' + item.tag)
          let index = keys.indexOf(key)
          if (index > -1) {
            keys.splice(index, 1)
          }
          cache[key].componentInstance.$destroy()
          delete cache[key]
        }
      }
    }
  }
  // 使用Vue.mixin的方法拦截了路由离开事件，并在该拦截方法中实现了销毁页面缓存的功能。
  Vue.mixin({
    beforeRouteLeave: function (to, from, next) {
      if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
        PageCachePlugin.keepAliveInstance = this.$vnode.parent.componentInstance
      }
      if (from.meta && from.meta.keepalive === false) {
        if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
          PageCachePlugin.keepAliveInstance = this.$vnode.parent.componentInstance
          if (this.$vnode.componentOptions) {
            let key = this.$vnode.key == null
              ? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag ? `::${this.$vnode.componentOptions.tag}` : '')
              : this.$vnode.key
            let cache = this.$vnode.parent.componentInstance.cache
            let keys = this.$vnode.parent.componentInstance.keys
            if (cache[key]) {
              if (keys.length) {
                let index = keys.indexOf(key)
                if (index > -1) {
                  keys.splice(index, 1)
                }
              }
              delete cache[key]
            }
          }
        }
        this.$destroy()
      }
      if (to.name === 'UserLogin') {
        if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache) {
          if (this.$vnode.parent.componentInstance.keys) {
            this.$vnode.parent.componentInstance.keys = []
          }
          let cache = this.$vnode.parent.componentInstance.cache
          for (let key in cache) {
            let item = cache[key]
            item.componentInstance.$destroy()
            delete cache[key]
          }
        }
      }
      let exitAppViews = ['TodoList', 'ContactList', 'HomePage', 'UserHome', 'UserLogin']
      for (let index in exitAppViews) {
        if (to.name === exitAppViews[index]) {
          CordovaUtils.setExitFlag()
          next()
          return
        }
      }
      next()
    }
  })
}

export default PageCachePlugin



// WEBPACK FOOTER //
// ./src/plugins/PageCachePlugin.js